// @flow
import * as React from "react"
import type { SpecialOpeningDates } from "data/affiliate/types"
import { formatOpeningHour } from "data/affiliate/formatters"
import { formatReadableFullYear } from "data/units/date/formatters"
import moment from "moment"
import { momentFromDateString } from "data/units/date/helpers"
import { compose, filter, sortBy, prop } from "ramda"
import { OpeningHoursTableWrap, Pair, Key, Val } from "./styled"
import { FieldTitle } from "componentsStyled/Typography/Titles"

type Props = {|
  data: SpecialOpeningDates,
|}

const filterUpcoming = filter(item =>
  momentFromDateString(item.date).isSameOrAfter(moment(), "day"),
)
const sortByDate = sortBy(prop("date"))

const Special = ({ data = [] }: Props) => {
  const transformed: SpecialOpeningDates = compose(
    sortByDate,
    filterUpcoming,
  )(data)

  if (!transformed.length) return null

  return (
    <React.Fragment>
      <FieldTitle>Special hours</FieldTitle>
      <OpeningHoursTableWrap>
        {transformed.map((x, i) => (
          <Pair key={i}>
            <Key nomargin>{formatReadableFullYear(x.date)}</Key>
            <Val nomargin black>
              {formatOpeningHour(x)}
            </Val>
          </Pair>
        ))}
      </OpeningHoursTableWrap>
    </React.Fragment>
  )
}

export default Special



// WEBPACK FOOTER //
// ./src/pages/Affiliate/Content/Info/OpeningHoursTable/Special.js